export const WELCOME_SCREEN_TRAIT = 'WELCOME_SCREEN' as const;
export const SETS_TRAIT = 'SETS' as const;
export const GROUPS_TRAIT = 'GROUPS' as const;
export const MATRIX_TRAIT = 'MATRIX' as const;
export const MEDIAFILE_TRAIT = 'MEDIAFILE' as const;
export const AUTH_TRAIT = 'AUTH' as const;
export const FILE_TRAIT = 'FILE' as const;
export const MAXDIFF_TRAIT = 'MAXDIFF' as const;

export type SchemaTrait =
  | typeof WELCOME_SCREEN_TRAIT
  | typeof GROUPS_TRAIT
  | typeof MEDIAFILE_TRAIT
  | typeof AUTH_TRAIT
  | typeof MATRIX_TRAIT
  | typeof FILE_TRAIT
  | typeof SETS_TRAIT
  | typeof MAXDIFF_TRAIT;
